import { render, staticRenderFns } from "./JarFactIpasRoleSearch.vue?vue&type=template&id=be503da6&"
import script from "./JarFactIpasRoleSearch.vue?vue&type=script&lang=js&"
export * from "./JarFactIpasRoleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports